module.exports = __webpack_public_path__ + "static/assets/c2eb7ac401b3b0e25a6ac49405ae221e.png";